import { __rest } from "tslib";
import { createElement, forwardRef } from 'rax';
import Input from './input';
const TextArea = (props, ref) => {
    const { rows = 3, multiline } = props, other = __rest(props, ["rows", "multiline"]);
    return <Input ref={ref} multiline rows={rows} {...other}/>;
};
TextArea.displayName = 'Input.TextArea';
export default forwardRef(TextArea);
